<!--
 * @Author: sharonQian 910170570@qq.com
 * @Date: 2026-01-15 18:38:00
 * @LastEditors: sharonQian 910170570@qq.com
 * @LastEditTime: 2026-01-15 18:38:08
 * @FilePath: \crm-product(西凤2.0crm)\found\views\tpm\views\activity\marketing_activity\components\agree_list.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <!-- 查询表单 -->
    <el-form :model="form" ref="form">
      <el-row :gutter="24">
        <el-col :span="8">
          <el-form-item prop="code">
            <el-input
              type="text"
              v-model="form.code"
              placeholder="模板编码"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item prop="name">
            <el-input
              type="text"
              v-model="form.name"
              placeholder="模板名称"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="8" style="text-align: right">
          <el-button type="primary" @click="search">查询</el-button>
          <el-button @click="reset('form')">重置</el-button>
        </el-col>
      </el-row>
    </el-form>
    <vxe-table
      border
      class="transfer-item"
      ref="xTable1"
      row-id="code"
      show-overflow
      :data="tableData"
      @checkbox-all="selectAllEvent"
      @checkbox-change="selectChangeEvent"
      :checkbox-config="{ checkRowKeys: selection }"
    >
      <vxe-table-column type="checkbox" width="36"></vxe-table-column>
      <vxe-table-column title="模板编码" field="code"></vxe-table-column>
      <vxe-table-column title="模板名称" field="name"></vxe-table-column>
      <vxe-table-column title="操作" align="center" width="80">
        <template v-slot="{ row }">
          <el-button type="text" @click="viewForm(row)">查看</el-button>
        </template>
      </vxe-table-column>
    </vxe-table>
    <div class="pagination">
      <el-pagination
        layout="total, sizes, prev, pager, next, jumper"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :page-sizes="paginationSize"
        :current-page="pagination.pageNum"
        :page-size="pagination.pageSize"
        :total="pagination.total"
      ></el-pagination>
    </div>
    <!-- 抽屉 -->
    <Modal
      :modalConfig.sync="modalConfig"
      :visible.sync="modalConfig.visible"
      @onClose="closeModal"
    >
      <component
        ref="modalForm"
        :is="formName"
        :formConfig="formConfig"
      />
      <div class="dialog-footer">
        <el-button icon="el-icon-close" type="danger" @click="closeModal"
          >关闭</el-button
        >
      </div>
    </Modal>
  </div>
</template>

<script>
import request from '@/found/utils/request';
import Modal from '@/found/components/modal';
import detailsInfo from '../../../../../../../src/views/dms/views/sharing_agreement/configuration_list/form/details/index';

export default {
  components: {
    Modal,
    detailsInfo,
  },
  data() {
    return {
      tableData: [],
      loading: false,
      form: {
        code: '',
        name: '',
      },
      pagination: {
        total: 0,
        pageSize: 15,
        pageNum: 1,
      },
      paginationSize: [5, 10, 15, 20, 50, 100, 150, 200],
      selection: [],
      selectRow: [],
      modalConfig: {
        title: '查看',
        type: 'Full',
        visible: false,
      },
      formName: 'detailsInfo',
      formConfig: {},
    };
  },
  props: {
    propsObj: Object,
    selectionList: Array,
  },
  async created() {
    this.selection = (this.selectionList || []).map((v) => v.code) || [];
    this.selectRow = this.selectionList || [];
    this.getTableList();
  },
  methods: {
    // 获取商品列表数据
    getTableList() {
      const data = {
        enableStatus: '009',
        templateCategory: '2',
        pageNum: this.pagination.pageNum,
        pageSize: this.pagination.pageSize,
        type: this.propsObj.type,
        ...this.form,
      };
      this.loading = true;
      request
        .post('/cps/cpsagreetemplate/list', data)
        .then((res) => {
          this.loading = false;
          if (res.success) {
            this.tableData = res.result.data;
            this.pagination.total = res.result.count;
          }
        })
        .catch((e) => {
          this.loading = false;
        });
    },
    // 搜索
    search() {
      this.pagination.pageNum = 1;
      this.getTableList();
    },
    // 重置
    reset(formName) {
      this.$refs[formName].resetFields();
      this.pagination.pageNum = 1;
      this.getTableList();
    },
    /** @desc 分页page * */
    handleCurrentChange(val) {
      this.pagination.pageNum = val;
      this.getTableList();
    },
    // 选择分页数量
    handleSizeChange(val) {
      this.pagination.pageSize = val;
      this.pagination.pageNum = 1;
      this.getTableList();
    },
    selectAllEvent({ records }) {
      this.selection.push(...records.map((v) => v.code));
      this.selectRow.push(...records);
      this.$emit('getAgreeList', this.selectRow);
    },
    selectChangeEvent({ records }) {
      this.selection = records.map((v) => v.code);
      this.selectRow = records;
      this.$emit('getAgreeList', this.selectRow);
    },
    viewForm(row) {
      this.formConfig = {
        code: 'view',
        agreeCode: row.code,
      };
      this.formName = 'detailsInfo';
      this.modalConfig = {
        title: '查看',
        type: 'Full',
        visible: true,
      };
    },
    // 关闭弹框
    closeModal() {
      this.modalConfig.visible = false;
    },
  },
};
</script>
<style lang="less" scoped>
.pagination {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
/deep/.el-pagination.is-background .el-pager li:not(.disabled).active {
  color: white !important;
}
</style>
